<div class="container">
    <div class="progress" #progress>&nbsp;</div>
</div>
